import { RoomMixerStreamEntity } from "@common/domain";
import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildRoomMixerVO } from "@youm-front/room/util/factory";
import { RoomMixerState, ROOM_MIXER_FEATURE_KEY } from "../reducers";

const roomMixerState = createFeatureSelector<RoomMixerState>(
  ROOM_MIXER_FEATURE_KEY
);

export const roomMixer = createSelector(
  roomMixerState,
  (state: RoomMixerState) => {
    const { roomMixer } = state;

    return roomMixer ? buildRoomMixerVO(roomMixer) : roomMixer;
  }
);

export const statesHead = createSelector(
  roomMixerState,
  (state: RoomMixerState) => {
    return state.states.length ? state.states[0] : null;
  }
);

export const stream = createSelector(
  roomMixerState,
  (state: RoomMixerState) => {
    return state.stream ? new RoomMixerStreamEntity(state.stream) : null;
  }
);
